import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function Skeletons({ ...props }) {
  return <Skeleton baseColor="var(--colors-neutral-grey-100)" highlightColor="var(--colors-neutral-white)" {...props} />;
}
